import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

const SHORTCUTS = [
  { keys: ['n'], desc: 'New habit (on Today page)' },
  { keys: ['g', 't'], desc: 'Go to Today' },
  { keys: ['g', 'h'], desc: 'Go to Habits' },
  { keys: ['g', 'c'], desc: 'Go to Calendar' },
  { keys: ['g', 's'], desc: 'Go to Stats' },
  { keys: ['g', 'r'], desc: 'Go to Templates' },
  { keys: ['g', ','], desc: 'Go to Settings' },
  { keys: ['?'], desc: 'Show keyboard shortcuts' },
  { keys: ['Esc'], desc: 'Close dialogs' },
];

const Kbd = ({ children }) => (
  <kbd className="inline-flex items-center justify-center min-w-[1.6rem] h-6 px-1.5 rounded-md border border-border bg-muted font-mono text-[11px] text-foreground">
    {children}
  </kbd>
);

export const ShortcutsDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="shortcuts-dialog" className="max-w-md">
      <DialogHeader>
        <DialogTitle className="font-heading">Keyboard shortcuts</DialogTitle>
        <DialogDescription>For power-users in their flow.</DialogDescription>
      </DialogHeader>
      <div className="divide-y divide-border">
        {SHORTCUTS.map((s, i) => (
          <div key={i} className="flex items-center justify-between py-3 text-sm">
            <span className="text-muted-foreground">{s.desc}</span>
            <span className="flex items-center gap-1">
              {s.keys.map((k, j) => (
                <span key={j} className="flex items-center gap-1">
                  {j > 0 && <span className="text-muted-foreground text-xs">then</span>}
                  <Kbd>{k}</Kbd>
                </span>
              ))}
            </span>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
